import './bootstrap';
import React from 'react';
import ReactDOM from 'react-dom';
import {GoogleOAuthProvider} from '@react-oauth/google';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  initAmplitude,
  sendAmplitudeEventData,
  setAmplitudeUserId,
  setAmplitudeUserProperties,
  setAmplitudeUserDevice,
} from './utils/Amplitude';
import {store, StoreContext} from './store';

require('dotenv').config();

initAmplitude();
sendAmplitudeEventData();
setAmplitudeUserId();
setAmplitudeUserProperties();
setAmplitudeUserDevice();

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <StoreContext.Provider value={store}>
        <App />
      </StoreContext.Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
